export default "__VITE_ASSET__DtcrNQHB__"